module.exports = __webpack_public_path__ + "static/media/Sidebar__dashboard.5f4b4779.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Sidebar__dashboard.svg
// module id = 593
// module chunks = 0